import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule, Routes } from "@angular/router";
import { JobseekerComponentComponent } from "./jobseeker-component.component";
import { DashboardJobComponent } from "./dashboard-job/dashboard-job.component";
import { ChatComponent } from "./chat/chat.component";
import { SettingsComponent } from "./settings/settings.component";
import { VerifyComponent } from "./settings/verify/verify.component";
import { ChangePasswordComponent } from "./settings/change-password/change-password.component";
import { CommonComponent } from "../shared/common"; 
import { ProfileComponent } from "./profile/profile.component";
import { JobsComponent } from "./jobs/jobs.component";
import { EmployerJobsComponent as JobsComponentProfile } from "./employer/employer-detail/jobs/jobs.component";
import { AppliedJobsComponent } from "./jobs/applied-jobs/applied-jobs.component";
import { SavedJobsComponent } from "./jobs/saved-jobs/saved-jobs.component";
import { EditProComponent } from "./profile/edit-pro/edit-pro.component";
import { SearhFilterComponent } from "./searh-filter/searh-filter.component";
import { AppliedJobsDetailComponent } from "./jobs/applied-jobs/applied-jobs-detail/applied-jobs-detail.component";
// import { SavedJobsDetailComponent } from "./jobs/saved-jobs/saved-jobs-detail/saved-jobs-detail.component";
import { NotificationComponent } from "./notification/notification.component";
import { EmployerDetailComponent } from "./employer/employer-detail/employer-detail.component";
import { AboutComponent } from "./employer/employer-detail/about/about.component";
import { EmployerListingComponent } from "./employer/employer-listing/employer-listing.component";
import { CommonSeeallComponent } from "./common-seeall/common-seeall.component";
import { JobRolesComponent } from "./job-roles/job-roles.component";
import { JobDetailComponent } from "./job-roles/job-detail/job-detail.component";
import { DeleteAccountPasswordComponent } from "./settings/delete-account-password/delete-account-password.component";
import { ViewMyreportComponent } from "./view-myreport/view-myreport.component";
import { SearchAppliedSaveJobsListComponent } from "./common/search-applied-save-jobs-list/search-applied-save-jobs-list.component"; 
const routes: Routes = [
  {
    path: "", component: JobseekerComponentComponent,
    children: [
      { path: "dashboard-job", component: DashboardJobComponent },
      { path: "chat", component: ChatComponent },
      { path: "view-report", component: ViewMyreportComponent },
      { path: "search/:search", component: SearhFilterComponent }, 
      {
        path: "profile", component: CommonComponent,
        children: [
          { path: "", component: ProfileComponent },
          { path: "edit", component: EditProComponent },
        ]
      },
      {
        path: "settings", component: CommonComponent,
        children: [
          { path: "", component: SettingsComponent },
          { path: "verify", component: VerifyComponent },
          { path: "change-password", component: ChangePasswordComponent },
          { path: "delete-account-password", component: DeleteAccountPasswordComponent },
        ]
      },
      { path: "detail/:id", component: AppliedJobsDetailComponent },
      {
        path: "all-jobs", component: CommonComponent,
        children: [
          { path: "", component: JobsComponent },
        ]
      },

      {
        path: "employer-choice", component: CommonComponent,
        children: [
          { path: "", component: EmployerListingComponent },
          {
            path: "details/:id", component: CommonComponent,
            children: [
              {
                path: "", component: EmployerDetailComponent,
                children: [
                  { path: "about", component: AboutComponent },
                  { path: "jobs", component: JobsComponentProfile },
                ]
              },
            ]
          },

        ]
      },

      {
        path: "job-roles", component: CommonComponent,
        children: [
          { path: "", component: JobRolesComponent },
          { path: "role/:id", component: JobDetailComponent },
        ]
      },

      {
        path: "applied-jobs", component: CommonComponent,
        children: [
          { path: "", component: AppliedJobsComponent },
        ]
      },
      {
        path: "saved-jobs", component: CommonComponent,
        children: [
          { path: "", component: SavedJobsComponent },
        ]
      },
      { path: "notification", component: NotificationComponent },
      { path: "seeall", component: CommonSeeallComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobseekerComponentRoutingModule { }
